import { render } from "./PdfPreviewPdfjs.vue?vue&type=template&id=f5686368&scoped=true"
import script from "./PdfPreviewPdfjs.vue?vue&type=script&lang=js"
export * from "./PdfPreviewPdfjs.vue?vue&type=script&lang=js"

import "./PdfPreviewPdfjs.vue?vue&type=style&index=0&id=f5686368&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5686368"]])

export default __exports__